import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as T_T from 'cryface';
import { mapStylesFactory } from '../../../shared/PropertyMapEpic/map.styles';

@Component
export default class PropertyMap extends Vue {
   public title: string = 'PropertyMap';

   public streetView: boolean = false;

   @Prop()
   public data: any;

   public center = { lat: 10, lng: 10 };

   public markers: any = [];

   public hasLocation = false;

   public styles = mapStylesFactory({
      showBussiness: true
   });

   @Watch('data', { immediate: true, deep: true })
   public onDataInput(val: any, oldVal: any) {
      if (T_T.simpleDetect(val)) {
         // console.log(val);
         if (T_T.simpleDetect(val.lat) && T_T.simpleDetect(val.lng)) {
            this.center = val;
            const markers = [];
            markers.push({ position: val });
            this.markers = markers;
            this.hasLocation = true;
         } else {
            this.hasLocation = false;
         }
      }
   }

   public centerMyListing(position: any) {
      const map: any = this.$refs.mapRef;
      map.panTo(position);
   }
}
